import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    Spinner,
} from "reactstrap";
import {useEffect, useState} from "react";
import {addDoc, collection} from "firebase/firestore";
import {useHistory, useParams} from "react-router-dom";
import {getDownloadURL, getStorage, ref, uploadBytes} from "firebase/storage";

import {getDb} from "../../util/Constants";
import moment from "moment";

const template2 = [
    {
        name: "5 Options A",
        optionsCount: 5,
        backgroundImageURL: "/5OptionsA.png"
    },
    {
        name: "5 Options B",
        optionsCount: 5,
        backgroundImageURL: "/5OptionsB.png"
    },
    {
        name: "5 Options C",
        optionsCount: 5,
        backgroundImageURL: "/5OptionsC.png"
    },
    {
        name: "8 Options",
        optionsCount: 8,
        backgroundImageURL: "/8Options.png"
    }

];

export default function EditQuestion(props) {
    const [imageFile, setImageFile] = useState(null);
    const [correctAnswer, setCorrectAnswer] = useState(0);
    const [miniGameOption, setMiniGameOption] = useState("Mini 1");
    const [templateType, setTemplateType] = useState(1);
    const [description, setDescription] = useState("");
    const [question, setQuestion] = useState("");
    const [options, setOptions] = useState([""]);
    const [allowSave, setAllowSave] = useState(true);
    const [loading, setLoading] = useState(null);
    const [questionNumber, setQuestionNumber] = useState(1);
    const [template2Type, setTemplate2Type] = useState("5 Options A");
    const [tem2Option, setTem2Option] = useState(null);
    const [optionsType, setOptionsType] = useState("text");
    const [mini4Options, setMini4Options] = useState(3);
    const { lName, questionIndex } = useParams();
    const history = useHistory();
    let imageURL = null;

    useEffect(async () => {

        await fetchMiniGameDetails();
        return () => {
        };
    }, [lName, questionIndex]);

    useEffect(() => {
        // Simulate an asynchronous operation
        // setTimeout(() => {
        //   setLoading(null);
        // }, 10000); // Adjust the delay as needed

    }, [])


    useEffect(() => {
        // console.log
        const data = template2.find((e) => e.name === template2Type);
        setTem2Option(data)
    }, [template2Type])

    const fetchMiniGameDetails = async () => {
        try {
            if (lName) {
                setMiniGameOption(lName);
                if (lName === "Mini 2")
                    setTemplateType(2)
                else if (lName === "Mini 1")
                    setTemplateType(1)
                else if (lName === "Mini 3")
                    setTemplateType(3)
                else if (lName === "Mini 4")
                    setTemplateType(4)
            }

            if (questionIndex) setQuestionNumber(questionIndex);
        } catch (error) {

        }
    };

    const handleImageUpload = async () => {
        const file = imageFile;

        const storage = getStorage();

        // Create a reference to a Firebase Storage location
        const storageRef = ref(storage, `images/Mini2Question${questionIndex}`);

        // Upload the file to the specified Firebase Storage location
        await uploadBytes(storageRef, file).then(async () => {
            // Get the download URL of the uploaded file

            await getDownloadURL(storageRef).then((url) => {
                imageURL = url;
            });
        });
    };

    const onFormSubmtHandler = async (e) => {
        e.preventDefault();


        try {

            setLoading("saving");
            if (templateType == 2 && !imageFile) {
                throw Error('Please Select an Image to upload.');
            }
            if (templateType == 2) {
                await handleImageUpload();
                var optionsImages = await handelOptions()
            }
            let optionsTemplate1 = [];
            if (templateType == 1) {
                options.map((element, index) => {
                    if (index < 4) return optionsTemplate1.push(element);
                });
            }

            const payload = {
                question: question,
                options: templateType == 1 ? optionsTemplate1 : templateType == 2 && optionsType === "image" ? optionsImages : options,
                miniGame: miniGameOption,
                miniGameTemplateType: Number(templateType),
                description: description,
                createdAt: moment().unix() * 1000,
                questionNumber: Number(questionNumber),

            }

            if (templateType == 2) {
                payload.backgroundImageURL = imageURL;
                payload.template2Type = template2Type;
                payload.optionsType = optionsType

            } else
                payload.correctAnswer = Number(correctAnswer);

            const docRef = await addDoc(collection(getDb(), "questions"), payload);
            setLoading(null);
            history.goBack()
        } catch (error) {
            setLoading(null);
            alert(error);
        }


    };

    const handelOptions = async () => {
        // console.log(options, "options")
        let uploadedFiles = [];

        const storage = getStorage();
        let index = 0;
        for (let item of options) {
            index++
            // Create a reference to a Firebase Storage location
            let storageRef = '';
            if (templateType === 2) {
                storageRef = ref(storage, `images/Mini2Question${questionIndex}option${index}`);
            }
            else {
                storageRef = ref(storage, `images/Mini4Question${questionIndex}option${index}`);
            }

            // Upload the file to the specified Firebase Storage location
            const data = await uploadBytes(storageRef, item)
            // Get the download URL of the uploaded file
            let downloadUrls = await getDownloadURL(data.ref);
            uploadedFiles.push(downloadUrls)
        }

        return uploadedFiles;
    }


    const handleChange = (index, event) => {
        const { name, value, files } = event.target;
        let arr = [...options];
        if (options.length == 1 && options[0] == "") arr = [];
        if (optionsType === "image") {
            if (files[0].size <= 500000) {
                arr[index] = files[0];
                setOptions(arr);
            } else {
                alert("Image should be less than 500kb.")
            }
        } else {
            arr[index] = value;
            setOptions(arr);
        }
    };

    const handleMini4Images = (index, event) => {
        const { files } = event.target;
        let arr = [...options];
        if (files[0].size <= 500000) {
            arr[index] = files[0];
            setOptions(arr);
        } else {
            alert("Image should be less than 500kb.")
        }
    }



    const mini34handler = async (e) => {
        e.preventDefault();
        setLoading("saving")
        let payload = {}
        if (templateType === 3) {
            payload = {
                question: question,
                miniGame: miniGameOption,
                questionNumber: Number(questionIndex),
                createdAt: moment().unix() * 1000

            }

            const docRef = await addDoc(collection(getDb(), "questions"), payload);
            history.push(`/admin/levels/${lName}`);

            setLoading(null)
        } else if (templateType === 4) {
            const imagesUpload = await handelOptions()
            payload = {
                question: question,
                miniGame: miniGameOption,
                questionNumber: Number(questionIndex),
                mini4Options: mini4Options,
                options: imagesUpload,
                createdAt: moment().unix() * 1000
            }
            const docRef = await addDoc(collection(getDb(), "questions"), payload);
            history.push(`/admin/levels/${lName}`);
            setLoading(null)
        }

    }


    return (
        <>
            <div className="header  pb-8 pt-5 pt-md-8" />
            <Container className="mt--9" fluid>
                <Row className="mb-4">
                    <Col>
                        <Card className="shadow">
                            <CardHeader className="d-flex justify-content-between align-items-center">
                                <h2 className="mb-0">Add Mini Game {templateType} Screen</h2>
                            </CardHeader>
                            {templateType === 1 || templateType === 2 ? <CardBody>
                                {loading === "data" ? (
                                    <div className="text-center py-5 mt-5">
                                        <Spinner color="primary" />
                                    </div>
                                ) : (
                                    <Form onSubmit={(e) => onFormSubmtHandler(e)}>

                                        <Row>
                                            {templateType !== 1 &&
                                                <>
                                                    <Col xs={"6"}>
                                                        <h3 className="mb-0">Select Template</h3>
                                                        <FormGroup>
                                                            <Input onChange={(e) => setTemplate2Type(e.target.value)}
                                                                value={template2Type}
                                                                className="form-control-alternative"
                                                                type="select"
                                                                name="template2Options" id="exampleSelect">
                                                                {template2.map((e) => (
                                                                    <option value={e.name}>{e.name}</option>
                                                                ))}
                                                            </Input>
                                                        </FormGroup>
                                                    </Col>

                                                    <Col md={"6"} className={"mb-4"}>
                                                        <div className={"containerss"}>
                                                            <a download={tem2Option.name + ".png"}
                                                                href={tem2Option.backgroundImageURL} title={tem2Option.name}>
                                                                <img
                                                                    src={
                                                                        tem2Option.backgroundImageURL}
                                                                    style={{
                                                                        height: "150px",
                                                                        objectFit: "contain",
                                                                        borderRadius: "5px"
                                                                    }}
                                                                    // className="img-fluid"
                                                                    alt="Selected Image"
                                                                />

                                                                <div className="overlay">Download</div>
                                                            </a>
                                                        </div>
                                                    </Col>
                                                </>

                                            }

                                            <Col xs={6}>
                                                <div className="">
                                                    <h3 className="mb-0">Title</h3>

                                                    <FormGroup>
                                                        <Input
                                                            type="textarea"
                                                            id="description"
                                                            rows={5}
                                                            maxLength="250"
                                                            value={description}
                                                            required
                                                            className="form-control-alternative"
                                                            onChange={(e) => setDescription(e.target.value)}
                                                        />
                                                    </FormGroup>
                                                </div>
                                            </Col>
                                            <Col xs={6}>
                                                <div className="">
                                                    <h3 className="mb-0">Scenario</h3>
                                                    <FormGroup>
                                                        <Input
                                                            type="textarea"
                                                            id="question"
                                                            rows={5}
                                                            maxLength="400"
                                                            required
                                                            className="form-control-alternative"
                                                            onChange={(e) => setQuestion(e.target.value)}
                                                        />
                                                    </FormGroup>
                                                </div>
                                            </Col>


                                        </Row>

                                        {templateType == 1 ? (
                                            <Row>
                                                <Col xs={12}>
                                                    <div className="d-flex justify-content-between">
                                                        <h3 className="mb-0">Options</h3>
                                                    </div>
                                                    <hr className="mt-3" />
                                                </Col>
                                                {Array.apply(null, Array(4)).map((data, index) => {
                                                    if (index < 4)
                                                        return (
                                                            <Col lg={6}>
                                                                <div className="p-3 border rounded mb-4 bg-lighter">
                                                                    <Row>
                                                                        <Col lg={12}>
                                                                            <FormGroup>
                                                                                <div
                                                                                    className="d-flex justify-content-between mb-2">
                                                                                    <Label
                                                                                        for="optionText"
                                                                                        className="col-8"
                                                                                    >
                                                                                        {` Option ${index + 1} `}
                                                                                    </Label>

                                                                                    <input
                                                                                        className="checkmarkMiniGameEdit"
                                                                                        type="radio"
                                                                                        id="html"
                                                                                        name="fav_language"
                                                                                        checked={
                                                                                            correctAnswer == index
                                                                                                ? true
                                                                                                : false
                                                                                        }
                                                                                        value={index}
                                                                                        onChange={(e) => {
                                                                                            setAllowSave(true);
                                                                                            setCorrectAnswer(index);
                                                                                        }}
                                                                                    />
                                                                                    <Label for="optionText">
                                                                                        {`Correct Answer`}
                                                                                    </Label>

                                                                                </div>
                                                                                <Input
                                                                                    rows={10}
                                                                                    type="text"
                                                                                    id="optionText"
                                                                                    maxLength="70"
                                                                                    value={data}
                                                                                    required
                                                                                    name="option"
                                                                                    className="form-control-alternative"
                                                                                    onChange={(event) =>
                                                                                        handleChange(index, event)
                                                                                    }
                                                                                />
                                                                            </FormGroup>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            </Col>
                                                        );
                                                })}
                                            </Row>
                                        ) : (
                                            <Row>

                                                <Col xs={"6"}>
                                                    <h3 className="mb-2">Select Options type</h3>
                                                    <FormGroup>
                                                        <Input onChange={(e) => setOptionsType(e.target.value)}
                                                            value={optionsType}
                                                            className="form-control-alternative"
                                                            type="select"
                                                            name="template2Options"
                                                            id="exampleSelect">
                                                            <option value={"text"}>{"Text"}</option>
                                                            <option value={"image"}>{"Image"}</option>

                                                        </Input>
                                                    </FormGroup>
                                                </Col>

                                                <Col xs={12}>
                                                    <div className="d-flex justify-content-between">
                                                        <h3 className="mb-0">Options in correct order</h3>

                                                        <label for="imageUpload"
                                                            class={imageFile ? "btn btn-success" : "btn btn-primary"}>
                                                            <i className="fa fa-upload mr-2" />
                                                            {imageFile ? "Image Selected" : "Upload Image"}
                                                        </label>

                                                        <input
                                                            type="file"
                                                            id="imageUpload"
                                                            accept=".jpg,.jpeg,.png"
                                                            onChange={(e) => {
                                                                const file = e.target.files[0];
                                                                const allowedTypes = ['image/jpeg', 'image/png'];
                                                                if (file && allowedTypes.includes(file.type)) {
                                                                    // handle image upload
                                                                    setImageFile(e.target.files[0])
                                                                } else {
                                                                    alert('Please upload an image file in jpeg/png format only. Other formats are not allowed.');
                                                                }
                                                            }}
                                                            style={{
                                                                display: "none"
                                                            }}
                                                        />
                                                    </div>
                                                    <hr className="mt-3" />
                                                </Col>
                                                {
                                                    Array.apply(null, Array(tem2Option.optionsCount)).map((data, index) => (
                                                        <Col lg={6}>
                                                            <div className="p-3 border rounded mb-4 bg-lighter">
                                                                <Row>
                                                                    <Col lg={12}>
                                                                        <FormGroup>
                                                                            <div
                                                                                className="d-flex justify-content-between mb-2">
                                                                                <Label for="optionText">
                                                                                    {` Option ${index + 1} `}
                                                                                </Label>
                                                                            </div>

                                                                            {optionsType === "image" ?
                                                                                <label htmlFor={"imageUploads" + index}
                                                                                    className={`btn btn-sm btn-secondary mb-1 d-inline-block}`}>
                                                                                    Choose File
                                                                                </label> : ""}
                                                                            <Input
                                                                                rows={10}
                                                                                type={optionsType === "image" ? "file" : "text"}
                                                                                id={"imageUploads" + index}
                                                                                value={data}
                                                                                required
                                                                                maxLength="70"
                                                                                name="option"
                                                                                className={`form-control-alternative ${optionsType === "image" ? "d-none" : ""}`}
                                                                                onChange={(event) =>
                                                                                    handleChange(index, event)
                                                                                }

                                                                            />
                                                                            {typeof options[index] === "object" && optionsType === "image" &&
                                                                                <img className="mt-2 d-block"
                                                                                    width={100}
                                                                                    src={URL.createObjectURL(options[index])} />}

                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    ))}
                                            </Row>
                                        )}

                                        <Row>
                                            <Col className="text-right">
                                                <Button
                                                    color="danger"
                                                    onClick={() => history.goBack()}
                                                    disabled={loading === "data"}
                                                >
                                                    Cancel
                                                </Button>
                                                {!allowSave ? (
                                                    <Button
                                                        color="primary"
                                                        onClick={() => {
                                                            alert("correct Answer is required");
                                                        }}
                                                        disabled={loading === "saving"}
                                                    >
                                                        {loading === "saving" ? (
                                                            <Spinner color="light" size="sm" />
                                                        ) : (
                                                            "Save"
                                                        )}
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        color="primary"
                                                        type="submit"
                                                        disabled={loading === "saving"}
                                                    >
                                                        {loading === "saving" ? (
                                                            <Spinner color="light" size="sm" />
                                                        ) : (
                                                            "Save"
                                                        )}
                                                    </Button>
                                                )}
                                            </Col>
                                        </Row>
                                    </Form>
                                )}
                            </CardBody> : <CardBody>
                                {
                                    loading === "data" ? (
                                        <div className="text-center py-5 mt-5">
                                            <Spinner color="primary" />
                                        </div>
                                    ) : (
                                        <Form onSubmit={(e) => mini34handler(e)}>
                                            <Row>

                                                {templateType === 4 && <Col xs={"3"}>
                                                    <h3 className="mb-0">Select Template</h3>
                                                    <FormGroup>
                                                        <Input onChange={(e) => setMini4Options(e.target.value)}
                                                            value={mini4Options}
                                                            className="form-control-alternative"
                                                            type="select"
                                                            name="template2Options" id="exampleSelect">
                                                            <option value={3}>Upto 3</option>
                                                            <option value={4}>Upto 4</option>
                                                            <option value={5}>Upto 5</option>
                                                            <option value={6}>Upto 6</option>
                                                            <option value={7}>Upto 7</option>
                                                        </Input>
                                                    </FormGroup>
                                                </Col>}
                                                {/* <Col xs={"6"}></Col> */}

                                                <Col xs={templateType === 4 ? "9" : "6"}>
                                                    <h3 className="mb-0">{templateType === 3 ? "Word" : "Scenario"}</h3>
                                                    <FormGroup>
                                                        <Input onChange={(e) => setQuestion(templateType === 3 ? e.target.value.trim() : e.target.value)}
                                                            value={question}
                                                            rows={templateType === 3 ? false : 10}

                                                            className="form-control-alternative"
                                                            minLength={templateType === 3 ? 4 : 400}
                                                            maxLength={templateType === 3 ? 10 : 400}
                                                            type={templateType === 3 ? "text" : "textarea"}
                                                            name="Question" id="exampleSelect">
                                                        </Input>
                                                    </FormGroup>
                                                </Col>
                                                {templateType === 4 && <Col xs={12}>
                                                    <div className="d-flex justify-content-between">
                                                        <h3 className="mb-0">Options in correct order</h3>


                                                    </div>
                                                    <hr className="mt-3" />
                                                </Col>}

                                                {templateType === 4 && Array.apply(null, Array(parseInt(mini4Options))).map((data, index) => (
                                                    <Col lg={6} key={index}>
                                                        <div className="p-3 border rounded mb-4 bg-lighter">
                                                            <Row>
                                                                <Col lg={12}>
                                                                    <FormGroup>
                                                                        <div className="d-flex justify-content-between mb-2">
                                                                            <Label for={`optionText${index}`}>
                                                                                {` Option ${index + 1} `}
                                                                            </Label>
                                                                        </div>

                                                                        <label htmlFor={`imageData${index}`} className="btn btn-sm btn-secondary mb-1 d-inline-block">
                                                                            Choose File
                                                                        </label>
                                                                        <Input
                                                                            type="file"
                                                                            id={`imageData${index}`}
                                                                            value={data}
                                                                            required
                                                                            name="option"
                                                                            className="form-control-alternative d-none"
                                                                            onChange={(event) => handleMini4Images(index, event)}
                                                                        />

                                                                        {options.length !== 0 && typeof options[index] === "object" && (
                                                                            <img
                                                                                className="mt-2 d-block"
                                                                                width={100}
                                                                                src={URL.createObjectURL(options[index])}
                                                                                alt={`Option ${index + 1}`}
                                                                            />
                                                                        )}
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                ))}

                                            </Row>
                                            <Row>
                                                <Col className="text-right">
                                                    <Button
                                                        color="danger"
                                                        onClick={() => history.goBack()}
                                                        disabled={loading === "saving"}
                                                    >
                                                        Cancel
                                                    </Button>
                                                    {!allowSave ? (
                                                        <Button
                                                            color="primary"
                                                            onClick={() => {
                                                                alert("correct Answer is required");
                                                            }}
                                                            disabled={loading === "saving"}
                                                        >
                                                            {loading === "saving" ? (
                                                                <Spinner color="light" size="sm" />
                                                            ) : (
                                                                "Save"
                                                            )}
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            color="primary"
                                                            type="submit"
                                                            disabled={loading === "saving"}
                                                        >
                                                            {loading === "saving" ? (
                                                                <Spinner color="light" size="sm" />
                                                            ) : (
                                                                "Save"
                                                            )}
                                                        </Button>
                                                    )}
                                                </Col>
                                            </Row>

                                        </Form>


                                    )
                                }


                            </CardBody>}
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}
